module.exports = __webpack_public_path__ + "static/media/outdoor-full-width.7e9ea235.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/industry/outdoor-full-width.png
// module id = 796
// module chunks = 0